import type { Context, PropsWithChildren } from 'react';
import React, { Component, createRef } from 'react';

import { getFirstFocusable } from '../../getFirstFocusable';

import type { FocusTwinsContextProps } from './FocusTwinsParent';
import { FocusTwinsContext } from './FocusTwinsParent';

export default class FocusTwinsChild extends Component<PropsWithChildren> {
  public static contextType: Context<FocusTwinsContextProps> = FocusTwinsContext;
  public context!: FocusTwinsContextProps;

  private containsFocus = false;
  private readonly ref = createRef<HTMLDivElement>();

  public render(): React.JSX.Element {
    return <FocusTwinsContext.Consumer>{this.receiveContext}</FocusTwinsContext.Consumer>;
  }

  public componentDidMount(): void {
    this.context.childIsAvailable(this.focus);
  }

  public componentWillUnmount(): void {
    if (this.containsFocus) {
      this.context.rescueChild();
    }
  }

  private renderContent() {
    return (
      <div onBlur={this.onBlur} onFocus={this.onFocus} ref={this.ref}>
        {this.props.children}
      </div>
    );
  }

  private readonly receiveContext = (value: FocusTwinsContextProps) => {
    this.context = value;

    return this.renderContent();
  };

  private readonly onFocus = () => {
    this.containsFocus = true;
  };

  private readonly onBlur = () => {
    this.containsFocus = false;
  };

  private readonly focus = () => {
    if (!this.ref.current) {
      return;
    }

    const firstFocusable = getFirstFocusable(this.ref.current, this.ref.current, true);
    if (firstFocusable) {
      firstFocusable.focus();
    }
  };
}
